import type { PrimaryFilterId } from '../../../filters/types/filters';
import type { ChartType } from '../../PageConfigProvider/types/chart';
import type { SecondaryDimensionValues } from '../../PageConfigProvider/types/dimension';
import type { MetricValues } from '../../PageConfigProvider/types/metric';
import { getChartSelectorConfig } from '../chart-selector-config';
import { isSelectableChartType } from './is-selectable-chart-type';
import { getAvailableSegments } from './segment-mapping';

export function resolveNextSecondaryDimension({
  chartType,
  primaryFilterId,
  metrics,
  currentSecondary,
}: {
  chartType: ChartType | undefined;
  primaryFilterId: PrimaryFilterId;
  metrics: MetricValues[];
  currentSecondary: SecondaryDimensionValues | undefined;
}): SecondaryDimensionValues | undefined {
  const allowed = getAvailableSegments({
    chartType,
    primaryFilterId,
    metrics,
    activitiesEnabled: true,
  });
  if (allowed.length === 0) {
    return undefined;
  }
  const allowedValues = new Set(allowed.map((o) => o.value));
  if (currentSecondary !== undefined && allowedValues.has(currentSecondary)) {
    return currentSecondary;
  }
  const selectorConfig =
    chartType !== undefined && isSelectableChartType(chartType)
      ? getChartSelectorConfig(chartType)
      : null;
  const forceSegment = selectorConfig?.forceSegment === true;
  if (currentSecondary === undefined && !forceSegment) {
    return undefined;
  }
  return allowed[0]?.value;
}
